export default __webpack_public_path__ + "static/media/Img0007.1f848292.png";